import script from "./message-stream.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-stream.vue?vue&type=script&lang=ts&setup=true"

import "./message-stream.vue?vue&type=style&index=0&id=884b75ee&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-884b75ee"]])

export default __exports__